import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ContainerBase } from '../../../core/base/container-base';


@Component({
    selector: 'app-backorder-page-container',
    templateUrl: './backorder-page-container.html',
    changeDetection: ChangeDetectionStrategy.OnPush
  })


  export class BackorderPageContainer {


  }